import { get } from 'lodash';

import de from './de';
import en from './en';

const translations = { de, en };

function translate(langs, key)
{
    for(let i = 0, n = langs.length; i < n; i++)
    {
        const value = get(translations[langs[i]], key);

        if(value) return value;
    }

    return key;
}

export { translate };